import { Link } from "react-router-dom";

export function GlossaryBand() {
  return (
    <section className="band-leaf overflow-hidden" data-testid="glossary-band">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-14 md:py-20 grid gap-10 lg:grid-cols-12 items-center">
        <div className="lg:col-span-7">
          <p className="overline overline-gold mb-4">The tea vocabulary</p>
          <h2 className="font-serif text-4xl md:text-5xl font-light tracking-tight leading-[1.05]">
            Seventy-five words <span className="italic">every tea drinker</span> should know.
          </h2>
          <p className="mt-6 text-base font-light text-[#f8f4ec]/75 max-w-[52ch]">
            From <em>astringency</em> to <em>Yixing</em> — a plain-English glossary of cultivars, processing
            terms, regions and rituals, cross-linked from every article on the site.
          </p>
          <div className="mt-8 flex flex-wrap gap-3">
            <Link to="/glossary" className="btn-paper" data-testid="glossary-band-cta">Browse the glossary</Link>
          </div>
        </div>
        <ul className="lg:col-span-5 grid grid-cols-2 gap-3 font-serif text-lg md:text-xl" aria-label="Sample glossary terms">
          {["Gongfu cha", "Muscatel", "Oxidation", "Terroir", "Kill-green", "Umami"].map((t, i) => (
            <li
              key={t}
              className={`rounded-card border border-[#f8f4ec]/15 bg-[#f8f4ec]/5 px-5 py-4 ${i % 3 === 1 ? "italic text-[#c9a45c]" : ""}`}
            >
              {t}
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
